import { render, staticRenderFns } from "./detail-admin-log.vue?vue&type=template&id=61c6a080"
import script from "./detail-admin-log.vue?vue&type=script&lang=js"
export * from "./detail-admin-log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports